<template>
  <div class="mt-4">
   <img alt="Hunter &amp; Gold" src="../assets/logo.png">
    <Home/>
  </div>
</template>

<script>
// @ is an alias to /src
import Home from '@/components/Home.vue'

export default {
  name: 'HomeView',
  components: {
    Home
  }
}
</script>
